import { FC } from 'react';
import { LeadStatus } from 'models/Lead';
import useQueryParams from 'hooks/useQueryParams';
import { leadStatusOptions } from 'constants/leadStatusOptions';
import { useParams } from 'react-router-dom';
import { useLeadTabs } from 'pages/Campaign/hooks';
import { CampaignType } from 'models/Campaign';

import './StatusTabs.styles.scss';
import classNames from 'classnames';

type StatusValue = 'TOTAL' | LeadStatus;

const StatusTabs: FC = () => {
  const { params, setMultipleQueryParams, removeQueryParam } = useQueryParams();
  const { id } = useParams<{
    id: string;
    campaignType: CampaignType;
  }>();

  const activeTab = params?.leadStatus || 'TOTAL';
  const { data: leadStatusData } = useLeadTabs(
    id,
    params?.campaignType as CampaignType,
  );

  const handleClick = (status: StatusValue) => {
    if (status !== 'TOTAL')
      setMultipleQueryParams({ leadStatus: status }, true);
    else removeQueryParam('leadStatus');

    removeQueryParam('page');
  };

  const isPersonalLead = params?.campaignType === CampaignType.Personal;

  return (
    <div className="status-tabs">
      {leadStatusOptions(isPersonalLead).map(({ label, value }) => {
        const isActive = activeTab === value;
        const statusCount = leadStatusData?.[value as LeadStatus] || 0;

        return (
          <button
            key={value}
            className={classNames(
              'tab',
              { active: isActive },
              value !== 'TOTAL' &&
                `tab--${label.toLowerCase().split(' ').join('-')}`,
            )}
            onClick={() => handleClick(value)}
          >
            {label} ({statusCount})
          </button>
        );
      })}
    </div>
  );
};

export default StatusTabs;
